import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MatTooltipModule } from "@angular/material/tooltip";
import { HomefourBannerComponent } from "./homefour-banner/homefour-banner.component";
import { HomefourBlogComponent } from "./homefour-blog/homefour-blog.component";
import { HomefourFeaturedServicesComponent } from "./homefour-featured-services/homefour-featured-services.component";
import { HomefourFunfactsComponent } from "./homefour-funfacts/homefour-funfacts.component";
import { HomefourIndustriesServeComponent } from "./homefour-industries-serve/homefour-industries-serve.component";
import { HomefourServicesComponent } from "./homefour-services/homefour-services.component";
import { HomefourTestimonialsComponent } from "./homefour-testimonials/homefour-testimonials.component";
import { HomefourWhatWeDoComponent } from "./homefour-what-we-do/homefour-what-we-do.component";
import { HomefourWhyChooseUsComponent } from "./homefour-why-choose-us/homefour-why-choose-us.component";
import { HomepageFourComponent } from "./homepage-four.component";
import { AboutpageHistoryComponent } from "../about-page/aboutpage-history/aboutpage-history.component";
import { SharedModule } from "@app/components/common/shared.module";

const routes: Routes = [
    {
        path: "",
        component: HomepageFourComponent,
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatCardModule,
        MatTooltipModule,
        SharedModule,
    ],
    providers: [],
    declarations: [
        HomepageFourComponent,
        HomefourBlogComponent,
        HomefourTestimonialsComponent,
        HomefourIndustriesServeComponent,
        HomefourServicesComponent,
        HomefourFunfactsComponent,
        HomefourWhatWeDoComponent,
        HomefourWhyChooseUsComponent,
        HomefourFeaturedServicesComponent,
        HomefourBannerComponent,
        AboutpageHistoryComponent,
    ],
})
export class HomepageFourModule {}
